import React, { useEffect } from "react";
import AuthLayout from "../components/AuthLayout";
import SignInForm from "../components/SignInForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SIGN_UP } from "../utils/constant";
function SignIn() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(SIGN_UP);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, []);

  const handleBackButtonClick = () => {
    window.location.href = process.env.REACT_APP_IMS_URL;
  };
  const token = localStorage.getItem("token");


  return (
    <div>
      <AuthLayout imageTitle={t("WelcomtoLogin")}
        imageSubtitle={t("loginToAccessPortal")}
        buttonName={t("createAccount_button")}
        // accountMsg={t("createaccount")}
        buttonClick={handleButtonClick}
        backButtonClick={handleBackButtonClick} 
        isFosa={true}>
       
        <SignInForm />
      </AuthLayout>
    </div>
  );
}

export default SignIn;